import { Input, KeyCode } from "../lib/Input";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import { WeapOptions } from "../type/WeapOptions";
import Player from "./Player";

export default class Gun {
    protected fireTimer: number = 0;
    reloadTimer: number = 0;

    player: Player;
    fireRate: number;
    magSize: number;
    bullets: number;
    damage: number;
    bulletSpeed: number;

    isReloading = false;
    reloadTime: number;

    mouseTrigger: 0|1|2|undefined;
    keyTrigger: KeyCode|undefined;

    constructor(player: Player, options: WeapOptions) {
        this.player = player;
        this.fireRate = options.fireRate;
        this.magSize = options.magSize;
        this.bullets = this.magSize;
        this.reloadTime = options.reloadTime;
        this.mouseTrigger = options.mouseTrigger;
        this.keyTrigger = options.keyTrigger;
        this.damage = options.damage;
        this.bulletSpeed = options.bulletSpeed;
    }

    Reload() {
        if (this.bullets === this.magSize || this.isReloading) return;
        this.isReloading = true;
        this.reloadTimer = 0;
    }

    onShoot() {}

    Shoot() {
        if (this.bullets === 0 || this.isReloading || this.fireTimer > 0) return;

        this.bullets--;
        this.onShoot();
        this.fireTimer = 1/this.fireRate;

        if (this.bullets === 0) {
            this.Reload();
        }
    }

    Update() {
        if (!this.player.isOwner || this.player.isDead) return;

        if (this.fireTimer > 0) {
            this.fireTimer -= Time.deltaTime;

            if (this.fireTimer <= 0) this.fireTimer = 0;
        }

        if (this.isReloading) {
            this.reloadTimer += Time.deltaTime;

            if (this.reloadTimer >= this.reloadTime) {
                this.isReloading = false;
                this.bullets = this.magSize;
            }
        }

        if (this.mouseTrigger != undefined && Input.GetMouseButton(this.mouseTrigger)) {
            this.Shoot();
        }

        if (Input.GetKeyDown(KeyCode.KeyR)) {
            this.Reload();
        }
    }

    Draw(yOffset: number) {
        if (this.player.isOwner) {
            const ctx = this.player.ctx;
            const engine = this.player.engine;

            ctx.fillStyle = '#ffffff55';
            engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50, 4));

            if (this.isReloading) {
                ctx.fillStyle = '#ffff80';
                engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50 * (this.reloadTimer/this.reloadTime), 4));
            } else {
                ctx.fillStyle = '#ffffff';
                engine.FillRect(this.player.transform.position.add(new Vector2(-25, this.player.size + yOffset)), new Vector2(50 * (this.bullets/this.magSize), 4));
            }
        }
    }

}